import { Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { GetApp } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { CDAOrderGrid } from './components/CDAOrderGrid';
import { useDocumentStore } from '@roc/feature-documents';
import { Button } from '@roc/ui';
import { useEffect } from 'react';
import { SecondCdaArrOrder } from './secondCdaArrOrder';
import { ConfirmCloseButtons } from './confirmCloseComponent';
import { isNil } from '@roc/feature-utils';
import { CDAOrderDetails } from './CDAOrderDetails';
import { LoanSubType } from '@roc/feature-utils';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(1),
  },
  downloadContainer: {
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    marginLeft: '17px',
  },
  icon: {
    fontSize: '24px',
    marginLeft: 4,
  },
  closeButtonContainer: {
    paddingTop: 16,
  }
}));

export const ManualArrSubmission = observer(({ loan, isInternal, isCda, isArr, onConfirm, url, borrowerEmail, isArrPaymentDone, isCdaPaymentDone }) => {

  const classes = useStyles();
  const { documentStore } = useDocumentStore();
  const { documentFormStore } = documentStore;
  const { cdaAndAppraisalOrderDetailsStore } = documentFormStore;
  const { propertiesWithDeviation, doesArrOrderExists } = cdaAndAppraisalOrderDetailsStore;
  const { loanId, loanSubType,properties} = loan

  const loanProperties =
    loanSubType === LoanSubType.RENTAL_PORTFOLIO
      ? (properties ?? [])
      : (cdaAndAppraisalOrderDetailsStore.secondAppraisalInformation?.properties ?? []);

  useEffect(() => {
    cdaAndAppraisalOrderDetailsStore.initArrOrderExists();
  }, []);

  if (isNil(doesArrOrderExists)) {
    return <></>;
  }

  const handleClose = () => {
    if (isInternal) {
      window.parent.postMessage('close-modal', '*');
      window.parent.postMessage('clear-style', '*');
    } else {
      documentStore.documentFormStore.setCurrentForm(null);
    }
  };

  const formatAddress = (property) => (
    [
      property.streetNumber,
      property.streetName,
      property.city,
      property.state,
      property.zipCode,
    ].join(', ')
  )

  return (
    <>
      {doesArrOrderExists ? (
        <CDAOrderDetails
          loanId={loanId}
          isInternal={isInternal}
          isCda={isCda}
          isArr={isArr}
          onConfirm={onConfirm}
          url={url}
          borrowerEmail={borrowerEmail}
          isCdaPaymentDone={isCdaPaymentDone}
          isArrPaymentDone={isArrPaymentDone}
          subtype={loanSubType}
        />
      ) : (
        <Grid container className={classes.container} justifyContent="center" spacing={1}>
          <Grid item xs={11} >
            <Typography variant="h5" gutterBottom>
              ARR Order Submission
            </Typography>
            <Typography > The ARR can be ordered for the following properties:</Typography>
            <ul style={{ marginLeft: '50px' }}>
              {loanProperties?.map(property => {
                return (<li>  {formatAddress(property)} </li>)
              })}
            </ul>
          </Grid>
          <Grid item container xs={11} justifyContent='flex-end' spacing={1} className={classes.container} direction='row'>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
                testId="close"
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid >
      )}
    </>
  );
});